export function SchemaLocalBusiness() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': 'https://toldos-malaga.es/#business',
    name: 'Toldos Málaga',
    description:
      'Reparación e instalación de toldos en Málaga. Tolderos profesionales con respuesta rápida 24/48h. Presupuesto gratis.',
    url: 'https://toldos-malaga.es',
    telephone: '+34951120770',
    email: 'info@toldos-malaga.es',
    image: 'https://toldos-malaga.es/og-image.jpg',
    logo: 'https://toldos-malaga.es/logo.svg',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Calle Pacífico 54, San Andrés',
      addressLocality: 'Málaga',
      addressRegion: 'Málaga',
      addressCountry: 'ES',
      postalCode: '29003',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 36.7213,
      longitude: -4.4214,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Saturday',
        opens: '10:00',
        closes: '14:00',
      },
    ],
    priceRange: '€€',
    areaServed: {
      '@type': 'City',
      name: 'Málaga',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function SchemaBreadcrumb({ items }: { items: { name: string; url: string }[] }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function SchemaPriceOffer({
  price,
  description,
  name,
}: {
  price: number;
  description?: string;
  name?: string;
}) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Offer',
    itemOffered: {
      '@type': 'Service',
      name: name || 'Servicio de toldos en Málaga',
      description: description || '',
    },
    priceSpecification: {
      '@type': 'PriceSpecification',
      price,
      priceCurrency: 'EUR',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}